import { mode } from "@chakra-ui/theme-tools";

export const inputStyles = {
  components: {
    Input: {
      variants: {
        primary: (props) => ({
          field: {
            bg: mode("sky.light", "navy.light")(props),
            color: mode("black", "white")(props),
            height: "70px",
            textAlign: "center",
            borderRadius: "2xl",
            _placeholder: {
              color: mode("#4c7aa5", "#4f5e6c")(props),
            },
            _disabled: {
              opacity: 0.5,
            },
          },
        }),
      },
    },
  },
};
